<div class="ep-container">

  <!-- Header -->
  <div class="ep-header">
    <div class="ep-header__info">
      <span class="ep-type-badge">{{ typeLabel }}</span>
      <span class="ep-label-text">{{ element.label }}</span>
    </div>
    <hub-button [size]="'lg'" [style]="'outline'" [icon]="'trash'" (buttonClick)="confirmRemove()">
    </hub-button>
  </div>

  <!-- ── Free Text Content ─────────────────────────────────────────────────── -->
  <div class="ep-section" *ngIf="isFreeText">
    <div class="ep-section__title">{{ 'bikeshop.receipt_template.properties.section_text_content' | translate }}</div>
    <div class="ep-field ep-field--col">
      <label class="ep-field__label">{{ 'bikeshop.receipt_template.properties.inline_edit_hint' | translate }}</label>
      <textarea
        class="ep-text-content"
        rows="4"
        [(ngModel)]="draft.content"
        (ngModelChange)="emit()"
        [placeholder]="'bikeshop.receipt_template.properties.text_placeholder' | translate">
      </textarea>
    </div>
  </div>

  <!-- ── Label ────────────────────────────────────────────────────────────── -->
  <!--<div class="ep-section">
    <div class="ep-field" *ngIf="element.elementType !== 'divider' && !isFreeText">
      <label class="ep-field__label">Show Label</label>
      <p-inputSwitch [(ngModel)]="draft.showLabel" (onChange)="emit()"></p-inputSwitch>
    </div>
  </div>-->

  <!-- ── Typography ────────────────────────────────────────────────────────── -->
  <div class="ep-section" *ngIf="showTextOptions">
    <div class="ep-section__title">{{ 'bikeshop.receipt_template.properties.section_typography' | translate }}</div>

    <div class="ep-field">
      <label class="ep-field__label">{{ 'bikeshop.receipt_template.properties.font_size' | translate }}</label>
      <p-dropdown
        [options]="fontSizeOptions"
        [(ngModel)]="draft.fontSize"
        (onChange)="emit()"
        styleClass="ep-font-size-dd"
        appendTo="body">
      </p-dropdown>
    </div>

    <div class="ep-field">
      <label class="ep-field__label">{{ 'bikeshop.receipt_template.properties.style' | translate }}</label>
      <div class="ep-style-buttons">
        <!--<button pButton class="p-button-text ep-style-btn" [class.active]="draft.fontWeight === 'bold'"
                (click)="setFontWeight(draft.fontWeight === 'bold' ? 'normal' : 'bold')">
          <b>B</b>
        </button>-->
        <hub-button [size]="'lg'" [style]="'outline'" [text]="'B'" (buttonClick)="setFontWeight(draft.fontWeight === 'bold' ? 'normal' : 'bold')">
        </hub-button>
        <hub-button [size]="'lg'" [style]="'outline'" [text]="'I'" (buttonClick)="setFontStyle(draft.fontStyle === 'italic' ? 'normal' : 'italic')">
        </hub-button>
        <!--<button pButton class="p-button-text ep-style-btn" [class.active]="draft.fontStyle === 'italic'"
                (click)="setFontStyle(draft.fontStyle === 'italic' ? 'normal' : 'italic')">
          <i>I</i>
        </button>-->
      </div>
    </div>

    <div class="ep-field">
      <label class="ep-field__label">{{ 'bikeshop.receipt_template.properties.alignment' | translate }}</label>
      <div class="ep-align-buttons">
        <hub-button [size]="'lg'" [icon]="'align-left'" [style]="'outline'" (buttonClick)="setTextAlign('left')"></hub-button>
        <hub-button [size]="'lg'" [icon]="'align-center'" [style]="'outline'" (buttonClick)="setTextAlign('center')"></hub-button>
        <hub-button [size]="'lg'" [icon]="'align-right'" [style]="'outline'" (buttonClick)="setTextAlign('right')"></hub-button>

        <!--<button pButton icon="pi pi-align-left" class="p-button-text ep-align-btn" [class.active]="draft.textAlign === 'left'" (click)="setTextAlign('left')"></button>
        <button pButton icon="pi pi-align-center" class="p-button-text ep-align-btn" [class.active]="draft.textAlign === 'center'" (click)="setTextAlign('center')"></button>
        <button pButton icon="pi pi-align-right" class="p-button-text ep-align-btn" [class.active]="draft.textAlign === 'right'" (click)="setTextAlign('right')"></button>-->

      </div>
    </div>

    <div class="ep-field">
      <label class="ep-field__label">{{ 'bikeshop.receipt_template.properties.text_color' | translate }}</label>
      <input type="color" class="ep-color-input" [(ngModel)]="draft.color" (change)="emit()" />
    </div>
  </div>

  <!-- ── Background ────────────────────────────────────────────────────────── -->
  <div class="ep-section" *ngIf="element.elementType !== 'divider'">
    <div class="ep-section__title">{{ 'bikeshop.receipt_template.properties.section_background' | translate }}</div>
    <div class="ep-field">
      <label class="ep-field__label">{{ 'bikeshop.receipt_template.properties.color' | translate }}</label>
      <input type="color" class="ep-color-input" [(ngModel)]="draft.backgroundColor" (change)="emit()" />
    </div>
  </div>

  <!-- ── Position & Size ───────────────────────────────────────────────────── -->
  <div class="ep-section">
    <div class="ep-section__title">{{ 'bikeshop.receipt_template.properties.section_position_size' | translate }}</div>

    <div class="ep-grid-2">
      <div class="ep-field ep-field--col">
        <label class="ep-field__label">{{ 'bikeshop.receipt_template.properties.x_mm' | translate }}</label>
        <input type="number" pInputText class="ep-num-input"
          [(ngModel)]="draft.x" (ngModelChange)="clampX()" min="0" [max]="canvasWith" step="0.5" />
      </div>
      <div class="ep-field ep-field--col">
        <label class="ep-field__label">{{ 'bikeshop.receipt_template.properties.y_mm' | translate }}</label>
        <input type="number" pInputText class="ep-num-input"
          [(ngModel)]="draft.y" (ngModelChange)="clampY()" min="0" [max]="canvasHeight" step="0.5" />
      </div>
      <div class="ep-field ep-field--col">
        <label class="ep-field__label">{{ 'bikeshop.receipt_template.properties.width_mm' | translate }}</label>
        <input type="number" pInputText class="ep-num-input"
          [(ngModel)]="draft.width" (ngModelChange)="emit()" min="3" [max]="canvasWith" step="0.5" />
      </div>
      <div class="ep-field ep-field--col">
        <label class="ep-field__label">{{ 'bikeshop.receipt_template.properties.height_mm' | translate }}</label>
        <input type="number" pInputText class="ep-num-input"
          [(ngModel)]="draft.height" (ngModelChange)="emit()" min="2" [max]="canvasHeight" step="0.5" />
      </div>
    </div>
  </div>

  <!-- ── Z-Order ────────────────────────────────────────────────────────────── -->
  <div class="ep-section">
    <div class="ep-section__title">{{ 'bikeshop.receipt_template.properties.section_layer_order' | translate }}</div>
    <div class="ep-z-order">
      <button pButton icon="pi pi-arrow-up" [label]="'bikeshop.receipt_template.properties.bring_forward' | translate" class="p-button-text p-button-sm ep-z-btn"
        (click)="bringForward.emit(element)">
      </button>
      <button pButton icon="pi pi-arrow-down" [label]="'bikeshop.receipt_template.properties.send_backward' | translate" class="p-button-text p-button-sm ep-z-btn"
        (click)="sendBackward.emit(element)">
      </button>
    </div>
  </div>

</div>
